import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {update} from "../../../app/setters/update.js";

export const useWycofajProjekt = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => update(`/${MAIN_REJESTR_API_SHORT}/wycofaj`, {id: id}),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
    });
};
